// extracted by mini-css-extract-plugin
export default {"block":"SetupIpaPricingPermissions_block__vZ4Bv","content":"SetupIpaPricingPermissions_content__jOgg9","loading":"SetupIpaPricingPermissions_loading__j8vFi"};